export const credits = {
  "Corporate Board": [
      { staff_name: "Tsehai Alfred", title: "Editor in Chief" },
      { staff_name: "Manuela Moreyra", title: "Managing Editor" },
      { staff_name: "Melinda Yao", title: "Publisher" }
  ],
  "Copy": [
    { staff_name: "Emily Spencer", title: "Head Copy Editor" },
    { staff_name: "Eli Trokenheim", title: "Deputy Copy Editor" },
    { staff_name: "Diego Carvajal Núñez", title: "Deputy Copy Editor" },
    { staff_name: "Vaishnavi Sirkay", title: "Deputy Copy Editor" },
    { staff_name: "Elizabeth Kushelevsky", title: "Deputy Copy Editor" },
    { staff_name: "Gigi Chen", title: "Deputy Copy Editor" },
  ],
  "Sports": [
    { staff_name: "Kaya Quebada", title: "Sports Editor" },
    { staff_name: "Nicholas Fink", title: "Deputy Sports Editor" },
    { staff_name: "Andrew Vincenti", title: "Deputy Sports Editor" },
    { staff_name: "Jillian Prunty", title: "Deputy Sports Editor" },
    { staff_name: "Emily Michaelsen", title: "Senior Staff Writer" },
    { staff_name: "Holden Lombardo", title: "Senior Staff Writer" },
    { staff_name: "Robby Swan", title: "Staff Writer" },
    { staff_name: "Annie Han", title: "Staff Writer" },
    { staff_name: "Arielle Rieder", title: "Head of Engagement" }
  ],
  "Photo": [
    { staff_name: "Audrea Chen", title: "Photo Editor" },
    { staff_name: "Esmerelda Paredes", title: "Deputy Photo Editor" },
  ],
    "Illustrations": [
    { staff_name: "Saumya Chaudhry", title: "Illustrations Editor" },
    { staff_name: "Anaïs Fotsing", title: "Deputy Illustrations Editor" },
  ],
  "Engineering": [
    { staff_name: "Julien Remy", title: "Co-Head of Engineering" },
    { staff_name: "Shriya Mani", title: "Co-Head of Engineering" },
    { staff_name: "Alyssa King", title: "Senior Developer" }
  ],
  "Product": [
    { staff_name: "Eugene Kim", title: "Head of Product" },
  ],
  
};
